export default "__VITE_ASSET__CXO995v___"